export const CurrentUserConfig = {
    storageTokenKeyName: "inlabB2BAccessToken",
}